<!-- Backdrop for the mobile off-canvas sidebar drawer (visible only when body has .sidebar-mobile-open) -->
<div class="sidebar-backdrop" (click)="closeMobileSidebar()"></div>

<header class="main-header">
    <a href="" class="logo">
        <span class="logo-mini">
            <img [src]="favImage" alt="favicon" />
        </span>
    
        <span class="logo-lg">
            <img [src]="logoImage" alt="logo" />
        </span>
    </a>
    <nav class="navbar navbar-static-top">
        <h2 class="app-brand">
            <a href="" class="sidebar-toggle" (click)="addBodyClass($event)">
                <img src="assets/images/nav-icon.svg" alt="">
            </a>
            <div *ngIf="deviceLocationLogo" class="location-logo-container">
                <img [src]="deviceLocationLogo" alt="Location Logo" class="location-logo">
            </div>
            <div class="location-info">
                <div *ngIf="deviceStoreNumber" class="store-number">
                    <strong>{{deviceStoreNumber}}</strong>
                </div>
                <div *ngIf="deviceStreetAddress" class="device-name">{{deviceStreetAddress}}</div>
                <div *ngIf="deviceCityStateZip" class="device-city-state-zip">{{deviceCityStateZip}}</div>
            </div>
            <!-- <span>{{ 'WELCOME_MESSAGE' | translate }}</span> -->
        </h2>
        <div class="d-flex align-items-center">
            <div class="theme-switch-wrapper">
                <button class="theme-toggle-btn" [ngClass]="currentTheme" (click)="toggleTheme()">
                    <span class="icon" [ngClass]="currentTheme"></span>
                    <span class="label-text">
                        {{ currentTheme === 'dark' ? 'Light Mode' : 'Dark Mode' }}
                    </span>
                </button>
            </div>
            <div class="user-dropdown">
                <a href="3" class="user-info-link" data-bs-toggle="dropdown" aria-expanded="false">
                    <div class="profile-pic">
                        <div class="ng-star-inserted">
                            <img alt="User Profile" class="custom-img-small ng-star-inserted" width="50" height="50"
                                [src]="userProfilePicture">
                        </div>
                    </div>
                    <div class="user-info">
                        <span class="user-name">{{ displayName }} <span class="user-role">{{ roleName }}</span></span>
                        <div class="user-time">
                            <small>{{ currentTime }}</small>
                        </div>
                    </div>
                    <i class="fa fa-angle-down"></i>
                </a>
                <ul class="dropdown-menu dropdown-menu-end drop-listing">
                    <li><a class="dropdown-item" (click)="openEditProfile()"> <i class="update-profile"></i> Edit
                            Profile</a></li>
                    <li><a class="dropdown-item" (click)="openChangePassword()"> <i class="fas fa-key"></i> Change
                            Password</a></li>
                    <li><a class="dropdown-item" (click)="logout()"> <i class="logout"></i> Logout</a></li>
                </ul>
            </div>
        </div>
    </nav>
</header>